import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GenericValue } from 'hisng';

@Component( {
    selector: 'res-research-area-plam',
    templateUrl: './research-area-plam.component.html',
} )
export class ResearchAreaPlamComponent {
    @Input() selectedResearchAreas: GenericValue[] = [];
    @Input() researchAreaDdKey: string;
    @Input() editMode = true;
    @Output() selectedResearchAreasChange = new EventEmitter();

    public onSelectedResearchAreasChange( $event: GenericValue[] ) {
        this.selectedResearchAreas = $event;
        this.selectedResearchAreasChange.emit( this.selectedResearchAreas );
    }
}
